export const callNative = (method, data) => {
  const ua = navigator.userAgent.toLowerCase()
  const isIos = ua.indexOf('iphone') > -1 || ua.indexOf('mac os') > -1
  if (isIos) {
    window.webkit.messageHandlers.JsBridge.postMessage({method, data})
  } else {
    if (data) {
      window.android[method](JSON.stringify(data))
    } else {
      window.android[method]()
    }
  }
}




// WEBPACK FOOTER //
// ./src/utils/native.js